<template>
    <div class="navigator-stage">
           
      <div :class="'navigator-stage-container schema-' + schema.Id" v-for="schema in stage.data" :key="schema.Id">
    
        <div v-if="schema.Options.length">
              
          <div v-if="schema.SelectionType == 1">
            <div :class="getOptionClass(stage,schema,option)" v-for="option in getOptions(schema)" :key="option.Id">
              <a href="#" @click.prevent="select(schema,option)">
                <!--<div v-for="id in option.ContentIds" :key="id">
                  <img class="content-img" :src="getImageUrl(id)" />
                </div>-->

                <div>{{ option.description }}</div>
                <img v-if="option.imageUrl" :src="option.imageUrl" width="200px" style="min-width: 200px">
                
                <div v-for="link in option.ContentLinks" :key="link">
                  <img class="content-img" :src="link" />
                </div>             
              </a>
            </div>
          </div>
          <div v-else-if="schema.SelectionType == 0">
            
              <!--<div v-if="schema.DataSource.Format.Description == 'Form Encoded'" >-->
              <div v-if="schema.DataSource.Id == 26">
                <!--<img :src="getImageUrl(stage)" width="400px" style="min-width: 400px" />-->
                <img :src="schema.Options[0].imageUri" width="400px" style="min-width: 400px" />
                      
                <!--
                <DxGallery
                  :data-source="getOptions(schema)"
                  :height="300"
                  :width="450"
                  :stretch-images="true"
                  :show-nav-buttons="true"
                  :show-indicator="false"      
                >
                  <template #item="{ data }">
                    <div class="img-content">
                      <img :src="getImageSrc(data.Data)">
                      <img :src="getImageUrl(data.id)" />
                    </div>
                  </template>
                </DxGallery>-->
              </div>
              <div v-else class="schema-grid">
                  <h6>{{ schema.Description }}</h6>            
                  <DxDataGrid :data-source="getOptions(schema)" :show-column-headers="false" :render-async="true" class="schema-list-grid">                  
                    <DxGrouping :auto-expand-all="false"/>
                    <DxPaging :enabled="false" />
                    <DxColumn v-if="schema.DataSource.DescriptionFieldName" :data-field="schema.DataSource.DescriptionFieldName" caption="Description" />             
                    <DxColumn v-if="schema.DataSource.GroupFieldName" :data-field="schema.DataSource.GroupFieldName" :group-index="0" group-cell-template="group" />
                    <DxColumn v-if="schema.DataSource.ValueFieldName" :data-field="schema.DataSource.ValueFieldName" caption="Value" />             
                    <template #group="{ data: item }">
                      <div>{{ item.key[0] || 'General' }}</div>
                    </template>                          
                  </DxDataGrid>
              </div>

          </div>  
          <div v-else-if="schema.SelectionType == 2" :class="'schema-list datasource-' + schema.DataSource.Id">
            <h6>{{ schema.Description }}</h6>             
            <DxDataGrid 
                @content-ready="(e) => optionsGridOnContentReady(e, schema)"       
                :schema-id="schema.Id"
                :data-source="getOptions(schema)" 
                :show-column-headers="false"
                :on-selection-changed="(e) => onSelectionChanged(e, schema.Id)"   
                :key-expr="schema.DataSource.KeyFieldName"  
                :render-async="true"
                @cell-prepared="(e) => optionsGridOnCellPrepared(e, schema)"
                class="schema-list-grid"
              >
                <DxPaging :enabled="false" />
      
                <DxSelection 
                  show-check-boxes-mode="always"
                  mode="multiple" />
                <DxGrouping :auto-expand-all="true"/>
                <DxColumn v-if="schema.DataSource.GroupFieldName" :group-index="1" :data-field="schema.DataSource.GroupFieldName" group-cell-template="group" />
                <!--<DxColumn v-if="schema.DataSource.KeyFieldName" :data-field="schema.DataSource.KeyFieldName" caption="Key Value" :width="200" />-->
                <DxColumn css-class="desc-column" v-if="schema.DataSource.DescriptionFieldName" :data-field="schema.DataSource.DescriptionFieldName" caption="Description" :width="230" />             
                <DxColumn v-if="schema.DataSource.ValueFieldName" :customize-text="(e) => valueColumn_customizeText(e, schema)" :data-field="schema.DataSource.ValueFieldName" caption="Value" :width="60" />             
                
                <DxColumn type="selection" caption="Select" :width="30" />
                            
                <template #group="{ data: item }">
                    <div class="group-cell">{{ item.key[0] || 'General' }}</div>
                </template>                          
              </DxDataGrid>
          </div>

          <div v-else-if="schema.SelectionType == 3" class="schema-list">
            <h6>{{ schema.Description }}</h6>    
            <form>         
            <div class="navigator-parameter form-group row" v-for="option in getOptions(schema)" :key="option.Id">
              
              <label :for="option.Id" class="col-sm-6 col-form-label">{{ option[schema.DataSource.DescriptionFieldName] }}</label>
              
              <div class="col-sm-6">
                <input :id="option.Id" type="text" class="form-control" :value="schema.Selection ? schema.Selection[option.KeyValue] : null" @change="(e) => onParameterChanged(e,schema,option)" />
              </div>
            </div>
            </form> 
          </div>
        </div>  
      </div>
    </div>
</template>

<script>    
  
    import CheckBox from "devextreme/ui/check_box";
    import { DxDataGrid, DxColumn, DxPaging, DxGrouping, DxSelection, DxButton } from 'devextreme-vue/data-grid';
    //import DxGallery from 'devextreme-vue/gallery';
    import { formatNumber } from "devextreme/localization";
    
    export default {
        name: 'NavigatorStage',
        components: {
          DxDataGrid,
          DxColumn,
          DxPaging,
          DxGrouping,
          DxSelection,
          DxButton,
          CheckBox
          //DxGallery,
        },
        props: {
          templateData: {
            type: Object,
            default: () => {}
          },
          onValueChanged: {
            type: Function,
            default: () => function() {}
          },
          onSubmitted: {
            type: Function,
            default: () => function() {}
          },
          onAccepted: {
            type: Function,
            default: () => function() {}
          },
          quoteId: {
            type: String
          }
        },
        data() {
            return {
                imgCache: {},    
                stage: this.templateData,
                modelId: '',
                changed: {}
                //admin: false
            };
        },
        created : function() {
          //this.admin = this.getPermissions("Organisation").Read;
          //console.log(this.stage.data);
        },
        methods: {
          select(schema,option) {
              var key = option[schema.DataSource.KeyFieldName];
              var caption = option[schema.DataSource.DescriptionFieldName];           
              this.onValueChanged(this.stage,schema,key,caption);
          },
          getImageSrc(data) {
          
            //this.getOptions(data);

            //var modelKey = '100018';
            
            //return "data:image/png;base64, " + data;

            return 'https://fleetcarestorage.blob.core.windows.net/vehicleimages/' + data.modelId + '.jpg';
          },
          getImageUrl(data) {


            //console.log(data);

           // console.log(data.modelId);

            //this.getOptions(data);

            //console.log(this.getOptions(data));

            //var modelKey = '100018';
            return 'https://fleetcarestorage.blob.core.windows.net/vehicleimages/' + data.modelId + '.jpg';

            //return this.apiUrl + 'content/' + id + '/data?key=' + this.getCombinedKey();
          },
          getOptionClass(stage,schema,option) {
            var cssClass = 'navigator-option stage-' + stage.Index;
            if(schema.Selection == option.KeyValue) {
              cssClass += ' selected';
            }
            return cssClass;
          },
          getOptions(schema) {
                        
            if(schema.DataSource.GroupFieldName && schema.ExcludeGroupNames) {
              var groupNames = schema.ExcludeGroupNames.split(',');
              //console.log(groupNames,schema.Options);
              if(schema.Options) {             
                return schema.Options.filter((option) => {
                  return !groupNames.includes(option[schema.DataSource.GroupFieldName]);
                });
              }
            }

            return schema.Options;
          },
          formatValue(value, format) {         
              if(!(format))
                  return value;
              if(!isNaN(Number.parseFloat(value))) {
                  return formatNumber(Number.parseFloat(value), JSON.parse(format));
              }

              return value;
          },
          valueColumn_customizeText(cellInfo, schema) {
            var value = cellInfo.value;
            
            var numericVal = Number.parseFloat(value);

            if(schema.DataSource.ValueModifier) {
              if(!isNaN(numericVal) && !isNaN(schema.DataSource.ValueModifier)) {
                value = numericVal * schema.DataSource.ValueModifier;
              } else {
                value = numericVal;
              }
            } else
              value = numericVal;

            return this.formatValue(value, '{ "type": "fixedPoint", "precision": 2 }');
          },
          showContent(content) {
            //console.log(content);
          },
          onSelectionChanged(e, schemaId) { 
          
            var key = e.currentSelectedRowKeys[0] ?? e.currentDeselectedRowKeys[0];
            this.changed[key] = true;
       
            var schema = this.stage.data.find(d => d.Id == schemaId);//e.component.schemaId);
            
            if(!(schema))
              return;

            var selectedRows = e.component.getSelectedRowsData();
            
            var selection = selectedRows.map(r => ({ group: r.group, description: r.description, value: r.KeyValue }));          
           
            var currItemKey = e.currentSelectedRowKeys[0];
            var currItem = selectedRows.find(item => item.KeyValue == currItemKey);

            if(currItem) {
              if(schema.SingleSelectionGroupNames) {
                selection.forEach(item => {
                  if(schema.SingleSelectionGroupNames.includes(item.group) && item.group == currItem.group) {
                    //Deselect all other items in the group                
                    var siblings = selectedRows.filter(s => s.group == item.group && s.KeyValue != currItemKey);                    
                    var siblingKeys = siblings.map(s => (s.KeyValue));
                    e.component.deselectRows(siblingKeys);
                  }
                });
              }
            }
            
            selectedRows = e.component.getSelectedRowsData();
            selection = selectedRows.map(r => ({ group: r.group, description: r.description, value: r.KeyValue }));          
                     
            this.onValueChanged(this.stage,schema,selection);//e.component.getSelectedRowKeys());
          },
          onParameterChanged(e,schema,option) {            
            var selection = schema.Selection || {};
            selection[option.KeyValue] = e.srcElement.value;

            this.onValueChanged(this.stage,schema,selection);
          },
          submit(schema) {
            this.onSubmitted(schema);
          },
          accept(e,row,schema) {            
            this.onAccepted(row.data);
          },
          optionsGridOnContentReady(e, schema) {
           
            //console.log(schema);   
            //console.log(schema.Selection);

            if(!(schema.Selection))
              return;
              
            try {
                var arr = schema.Selection;
                if(!Array.isArray(arr))
                    arr = JSON.parse(arr);  
                if(Array.isArray(arr)) {
                    var selection = arr.map(s => s.value);

                    //console.log(arr);

                    e.component.selectRows(selection, false);

                    var selectedRows = e.component.getSelectedRowsData();
                    selection = selectedRows.map(r => ({ group: r.group, description: r.description, value: r.KeyValue }));
                   
                    //console.log(selection);

                    //schema.Selection = selection;
                }
            }
            catch(err) {
                console.log("Error:",err);
            }
          },
          optionsGridOnCellPrepared(e, schema) {

            if(e.data.DataSourceId == 57) {
              if(e.column.type == "selection") {
               
                var nullQuoteId = (this.quoteId == null) || (this.quoteId == ":id");

                var isChanged = this.changed[e.key] != null;
                var preSelected = e.data.selected;

                var arr = schema.Selection;
                var userSelected = false;
                if(Array.isArray(arr)) {
                  userSelected = arr.filter(a => a.value == e.key).length > 0;
                }
             
                var isSelected = userSelected | preSelected && !isChanged && nullQuoteId;
               
                //console.log(arr);

                //console.log(e.key, arr, preSelected, userSelected, e.data.selected, isChanged, nullQuoteId);

                var checkBox = CheckBox.getInstance(e.cellElement.childNodes[0]);  
                if(nullQuoteId && !e.data.optional) {
                  e.cellElement.style.pointerEvents = 'none';
                  e.component.selectRows(e.key,true);
                  checkBox.option('value',true);
                }

                //console.log(e.key, e.data.optional);
                
                if(isSelected) {// || (e.data.selected && nullQuoteId)) {// && !this.changed[e.key]) {              
                  e.component.selectRows(e.key,true);
                  checkBox.option('value',true);
                }

                checkBox.option('disabled',!e.data.optional);
                checkBox.option('readOnly',!e.data.optional);

                // The grid—not the checkbox—handles the selection toggle on cell click,
                // so disabled/readOnly alone won't stop it. Block the click at the cell.
                e.cellElement.style.pointerEvents = !e.data.optional ? 'none' : 'auto';

              }
              else if(e.column.caption == 'Value') {

                if (!e.data.showValue) {
                  e.cellElement.style.visibility = 'hidden';
                }
              }
            }
          }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  div.navigator-stage-container {
    float: left
  }

  .navigator-stage {
    padding: 10px;
    overflow-y: auto;
    background: white;
    border-radius: 10px;
  }
  .navigator-option {
    text-align: left;
  }  
  .navigator-option.stage-0 {
    float: left; 
    padding: 20px;
    text-align: center;
    height: 200px;
  }
  .navigator-option.selected {
    font-weight: bold;
  }
  .navigator-option > a {
    color: black;
    text-decoration: none;
  }
  .navigator-option > a:hover {
     text-decoration: underline;
  }
  .navigator-parameter {
    margin-bottom: 10px;
  }
  div.schema-gallery {
    float: left;
    width: 450px;
    margin-right: 50px;
  }
  div.schema-list {
    float: none;
    width: 100%;
    margin-right: 50px;
    margin-bottom: 20px;
    min-width: 400px;
    max-width: 400px; 
  }
  div.schema-grid {
    float: none;
    width: 100%;
    margin-right: 50px;
    margin-bottom: 20px;
    min-width: 300px;
    max-width: 300px; 
  }
  div.response-grid {
    float: left;
    width: 1000px;
    margin-right: 50px;
    margin-bottom: 20px;
  }
  
  a.accept-button
  {
    color: white!important;
  }

  button.request-quote-button {
    position: relative;
    top: 250px;
    left: -200px;
  }
  img.content-img {
    max-width: 150px;
    min-width: 150px;
  }
  .schema-list-grid {
    max-width: 500px!important;
  }
    
  .dx-datagrid .dx-row > td.desc-column {
    padding: 0!important;
  }
  
  @media (max-width: 992px) {
     div.navigator-stage-container {
        display: inline-block;
     }
     #results-grid-0 > div {
      min-width: unset;
      max-width:100%;
      padding: 0px;
     }
     div.schema-grid,
     .schema-list-grid {
      max-width: 95%!important;
    }
    
     img.content-img {
      max-width: 75px;
      min-width: 75px;
    }
    .navigator-option.stage-0 {
      padding: 20px;
      text-align: center;
      height: 100px;
      min-width: 120px;
    }    
  }
</style>

